<script lang="ts">
  import afternoon from "../assets/radar-afternoon.png";
  import evening from "../assets/radar-evening.png";
  import morning from "../assets/radar-morning.png";
  import standard from "../assets/radar-standard.png";
  import { artPeriod } from "../model";

  let { now }: { now: Date } = $props();
  const art = { morning, standard, afternoon, evening };
</script>

<div class="radar-artwork" aria-hidden="true">
  <img src={art[artPeriod(now)]} alt="" />
</div>
